import React from "react";

const Copy = ({ style }) => (
  <svg
    width="1.29rem"
    height="1.24rem"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5619 13.885V18.3181C17.5619 22.0124 16.0842 23.4902 12.3899 23.4902H7.95669C4.26239 23.4902 2.78467 22.0124 2.78467 18.3181V13.885C2.78467 10.1907 4.26239 8.71295 7.95669 8.71295H12.3899C16.0842 8.71295 17.5619 10.1907 17.5619 13.885Z"
      fill="#384247"
    />
    <path
      d="M18.723 2.37988H14.2899C11.1762 2.37988 9.64451 3.4371 9.23948 5.97382C9.11591 6.74779 9.76875 7.39358 10.5525 7.39358H12.39C16.8231 7.39358 18.8814 9.45183 18.8814 13.885V15.7224C18.8814 16.5062 19.5272 17.159 20.3011 17.0355C22.8379 16.6304 23.8951 15.0987 23.8951 11.9851V7.55191C23.8951 3.8576 22.4173 2.37988 18.723 2.37988Z"
      fill="#384247"
    />
  </svg>
);
export default Copy;
